import { Component, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { auditTime, distinctUntilChanged } from "rxjs/operators";
import * as fromApp from "../../../../store/app.reducer";
import * as _ from "lodash";
import * as CheckboxPromotionsActions from "../store/checkbox-promotions.actions";
import { ToastController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import {
  applyCustomDiscountPresetValue,
  changeCustomDiscountPromotionType,
  CUSTOM_DISCOUNT_FIXED_MIN,
  CUSTOM_DISCOUNT_PERCENT_MAX,
  CUSTOM_DISCOUNT_PERCENT_MIN,
  CUSTOM_DISCOUNT_PERCENT_PRESETS,
  getFixedCustomDiscountMaxValue,
  initializeCustomDiscountPromotion,
  normalizeCheckboxPromotions,
  persistCheckboxPromotions,
  stepCustomDiscountPromotionValue,
} from "../checkbox-promotions.helpers";

@Component({
  selector: "app-checkbox-promotions-online-payment",
  templateUrl: "./checkbox-promotions-online-payment.component.html",
  styleUrls: ["./checkbox-promotions-online-payment.component.scss"],
})
export class CheckboxPromotionsOnlinePaymentComponent
  implements OnInit, OnDestroy
{
  public checkboxPromotions: any;
  public fixedDiscountMaxValue: number;
  public subtotal: number;
  public onlinePaymentOnlyPromos: any;
  public finalPriceLoading: boolean;
  public percentMaxValue = CUSTOM_DISCOUNT_PERCENT_MAX;
  public percentMinValue = CUSTOM_DISCOUNT_PERCENT_MIN;
  public percentPresetValues = CUSTOM_DISCOUNT_PERCENT_PRESETS;
  public fixedMinValue = CUSTOM_DISCOUNT_FIXED_MIN;
  public thereIsPromoOnlinePaymentOnly;
  private subTotalNoPromos: any;
  private subscriptions: Subscription[] = [];
  constructor(
    private store: Store<fromApp.AppState>,
    private toastController: ToastController,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.subscriptions.push(
      this.store.select("disableFinalPrice").subscribe((state) => {
        if (
          state &&
          !_.isEqual(state.disableFinalPrice, this.finalPriceLoading)
        ) {
          this.finalPriceLoading = _.cloneDeep(state.disableFinalPrice);
        }
      })
    );

    this.subscriptions.push(
      this.store
        .select("checkboxPromotions")
        .pipe(distinctUntilChanged())

        .subscribe((state) => {
          const normalizedCheckboxPromotions = normalizeCheckboxPromotions(
            state?.checkboxPromotions
          );

          if (
            state &&
            state.checkboxPromotions &&
            !_.isEqual(this.checkboxPromotions, normalizedCheckboxPromotions)
          ) {
            this.checkboxPromotions = normalizedCheckboxPromotions;

            this.thereIsPromoOnlinePaymentOnly = !!_.find(
              this.checkboxPromotions,
              { onlinePaymentOnly: true }
            );

            this.onlinePaymentOnlyPromos = _.filter(
              this.checkboxPromotions,
              (promos) => {
                return promos.onlinePaymentOnly;
              }
            );
          }

          if (
            state &&
            !_.isEqual(this.subTotalNoPromos, state.subTotalNoPromos)
          ) {
            if (state.subTotalNoPromos) {
              this.subTotalNoPromos = parseInt(
                _.cloneDeep(state.subTotalNoPromos)
              );
            }
            //console.log("subtotal no promos from state", this.subTotalNoPromos);
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select("cartPrices")
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          if (
            state &&
            state.cartPrices &&
            !_.isEqual(state.cartPrices.subtotal, this.subtotal)
          ) {
            this.subtotal = _.cloneDeep(state.cartPrices.subtotal);
            this.fixedDiscountMaxValue = getFixedCustomDiscountMaxValue(
              this.subtotal
            );
          }
        })
    );
  }

  clickCheckBoxPromotionDebounce = _.debounce((promo) => {
    this.clickCheckboxPromotion(promo);
  }, 20);

  clickCheckboxPromotion(promo) {
    console.log("promo", promo);
    console.log("checkboxPromotions", this.checkboxPromotions);
    var index = _.findIndex(this.checkboxPromotions, {
      id: promo.id,
    });
    console.log("index", index);
    if (index !== -1) {
      console.log("subTotalNoPromos", this.subTotalNoPromos);
      if (promo.couponSelected) {
        this.checkboxPromotions[index].promoCheckbox = false;
        this.presentErrorToast(
          this.translateService.instant(
            "cart.cart-components.checkbox-promotions.promotions-cannot-be-combined-with-the-selected-coupons"
          ),
          "danger"
        );
      } else if (this.subTotalNoPromos === 0) {
        this.checkboxPromotions[index].promoCheckbox = false;
        this.presentErrorToast(
          this.translateService.instant(
            "cart.cart-components.checkbox-promotions.promotion-is-not-applied-to-promo-products"
          ),
          "danger"
        );
      } else {
        if (
          this.checkboxPromotions[index].custom_discount &&
          this.checkboxPromotions[index].promoCheckbox
        ) {
          this.checkboxPromotions[index] = initializeCustomDiscountPromotion(
            _.cloneDeep(this.checkboxPromotions[index])
          );
        }
        if (
          this.checkboxPromotions[index].promoCheckbox &&
          this.checkboxPromotions[index].onlinePaymentOnly
        ) {
        }
        this.checkboxPromotions = normalizeCheckboxPromotions(
          this.checkboxPromotions
        );
        persistCheckboxPromotions(this.checkboxPromotions);
        console.log("calculateCartInline after clickCheckboxPromotion");
        this.store.dispatch(
          new CheckboxPromotionsActions.SetCheckboxPromotions(
            _.cloneDeep(this.checkboxPromotions)
          )
        );
      }
    }
  }

  changeCustomDiscountType(promo, discountType) {
    this.setPromotionState(
      promo,
      changeCustomDiscountPromotionType(_.cloneDeep(promo), discountType)
    );
    this.persistCheckboxPromotionsState();
  }

  selectCustomDiscountPreset(promo, value) {
    this.setPromotionState(
      promo,
      applyCustomDiscountPresetValue(_.cloneDeep(promo), value, this.subtotal)
    );
    this.persistCheckboxPromotionsState();
  }

  stepCustomDiscountValue(promo, direction) {
    this.setPromotionState(
      promo,
      stepCustomDiscountPromotionValue(
        _.cloneDeep(promo),
        direction,
        this.subtotal
      )
    );
    this.persistCheckboxPromotionsState();
  }

  updateCustomDiscountFixedValue(promo, value) {
    this.setPromotionState(
      promo,
      applyCustomDiscountPresetValue(_.cloneDeep(promo), value, this.subtotal)
    );
    this.persistCheckboxPromotionsState();
  }

  async presentErrorToast(message, color) {
    const toast = await this.toastController.create({
      message: message,
      duration: 3000,
      position: "middle",

      color: color,
      buttons: [
        {
          side: "end",
          icon: "assets/ionicons/close.svg",

          handler: () => {
            // console.log("Toast Closed");
          },
        },
      ],
    });
    toast.present();
  }

  trackbyFnc(index, item) {
    return item.promo_id;
  }

  private setPromotionState(promo, nextPromotionState) {
    const promotionIndex = _.findIndex(this.checkboxPromotions, {
      id: promo?.id,
    });

    if (promotionIndex !== -1) {
      this.checkboxPromotions[promotionIndex] = _.cloneDeep(nextPromotionState);
    }
  }

  private persistCheckboxPromotionsState() {
    this.checkboxPromotions = normalizeCheckboxPromotions(
      this.checkboxPromotions
    );

    this.store.dispatch(
      new CheckboxPromotionsActions.SetCheckboxPromotions(
        _.cloneDeep(this.checkboxPromotions)
      )
    );
    persistCheckboxPromotions(this.checkboxPromotions);
  }

  ngOnDestroy() {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach((sub) => {
        sub.unsubscribe();
      });
    }
  }
}
